import { PermissionGroupV2, PermissionV2 } from '../../../types/role';

/** Flat permission list → groups for RoleForm, in first-seen group order. */
export function groupPermissions(permissions: PermissionV2[]): PermissionGroupV2[] {
  const byGroup = new Map<string, PermissionV2[]>();
  for (const p of permissions) {
    const list = byGroup.get(p.group) ?? [];
    list.push(p);
    byGroup.set(p.group, list);
  }
  return [...byGroup].map(([group, list]) => ({
    group,
    permissions: [...list].sort((a, b) => a.title.localeCompare(b.title)),
  }));
}
